/** Confirmed from the deploy output on 2026-08-29. */
const SIGNUP_ENDPOINT =
  "https://us-central1-minglemunch-36928.cloudfunctions.net/signUpForEvent";

export type SignupRequest = {
  eventId: string;
  name: string;
  phone: string;
  email?: string;
  smsConsent: boolean;
};

export type SignupResult =
  | { status: "pending"; paymentLink: string }
  | { status: "waitlisted"; position: number };

export async function signUpForEvent(
  body: SignupRequest
): Promise<SignupResult> {
  const response = await fetch(SIGNUP_ENDPOINT, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });

  const data = await response.json().catch(() => ({}));

  if (!response.ok) {
    // The function sends a readable sentence for every rejection it expects.
    throw new Error(data?.error ?? "Something went wrong. Please try again.");
  }

  return data as SignupResult;
}

export const MAX_CONFIRMED_DEFAULT = 7;

/** Below this many seats we show the exact count instead of just "Open". */
export const SEATS_LEFT_THRESHOLD = 5;

export type Availability =
  | { kind: "open" }
  | { kind: "limited"; seatsLeft: number }
  | { kind: "full" };

export function getAvailability(event: {
  maxConfirmed?: number;
  confirmedCount?: number;
}): Availability {
  const max = event.maxConfirmed ?? MAX_CONFIRMED_DEFAULT;
  const seatsLeft = Math.max(0, max - (event.confirmedCount ?? 0));

  if (seatsLeft === 0) return { kind: "full" };
  if (seatsLeft < SEATS_LEFT_THRESHOLD) return { kind: "limited", seatsLeft };
  return { kind: "open" };
}
